import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, GuardResult, MaybeAsync } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PageGuardService  {
  role: string;
  pages: any;
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> {
    return JSON.parse(localStorage.getItem('role')) === route.data.role.toString();
  }
}
